const getPriceInfo = ({
  price: {
    current,
    previous,
    rrp,
    isOutletPrice,
    isMarkedDown,
    previousEndDate
  }
}) => {
  const currentPrice = current.value;
  const originalPrice = isOutletPrice
    ? rrp.value
    : isMarkedDown
    ? previous.value
    : null;

  return {
    currentPrice,
    originalPrice,
    isDiscounted: originalPrice !== null,
    isOutlet: isOutletPrice,
    previousEndDate
  };
};

export default getPriceInfo;
